import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { loadingToggleAction,loginAction,
} from '../../admin/src/store/actions/AuthActions';

// Styles
import '../../admin/src/vendor/bootstrap-select/dist/css/bootstrap-select.min.css';
import '../../admin/src/css/style.css';

// Images
import loginbg from "../../admin/src/images/pic1.png";

// Logo URL from Cloudinary
const logo = "https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg";

function Login (props) {
  const [email, setEmail] = useState('dioplemaire99@gmail.com');
    let errorsObj = { email: '', password: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState('mariama@SO2024');

    const dispatch = useDispatch();
	const navigate = useNavigate()
	const [searchParams] = useSearchParams();
	const redirectTo = searchParams.get('redirect') || '';
    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is Required';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is Required';
            error = true;
        }
        setErrors(errorObj);
        if (error) {
            return;
        }
        // Appel API via les actions Redux existantes
        dispatch(loadingToggleAction(true));
        dispatch(loginAction(email, password, navigate, redirectTo));
    }

  return (
		<div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
			<div className="login-aside text-center  d-flex flex-column flex-row-auto">
				<div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
					<div className="text-center mb-4 pt-5">
						<img src={logo} alt="" />
					</div>
					<h3 className="mb-2">Bienvenue! sur SenOffre</h3>
					<p>Plateforme des appels d’offres publics et privés du  <br />Sénégal</p>
				</div>
				<div className="aside-image" style={{backgroundImage:"url(" + loginbg + ")"}}></div>
			</div>
			<div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
				<div className="d-flex justify-content-center h-100 align-items-center">
					<div className="authincation-content style-2">
						<div className="row no-gutters">
							<div className="col-xl-12 tab-content">
								<div id="sign-in" className="auth-form   form-validation">
									{props.errorMessage && (
										<div className='bg-red-300 text-red-900 border border-red-900 p-1 my-2'>
											{props.errorMessage}
										</div>
									)}
									{props.successMessage && (
										<div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
											{props.successMessage}
										</div>
									)}
									<form onSubmit={onLogin}  className="form-validate">
										<h3 className="text-center mb-4 text-black">S'identifier</h3>
										{props.showLoading && (
                                            <div className="d-flex align-items-center justify-content-center mb-3">
                                                <div className="spinner-border text-success me-2" role="status" style={{width: '1.5rem', height: '1.5rem'}}>
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <span className="text-muted">Connexion en cours...</span>
                                            </div>
                                        )}
										<div className="form-group mb-3">
											<label className="mb-1"  htmlFor="val-email"><strong>Email</strong></label>
											<div>
												<input type="email" className="form-control"
													value={email}
												   onChange={(e) => setEmail(e.target.value)}
												   placeholder="Type Your Email Address"
												   disabled={props.showLoading}
												/>
											</div>
											{errors.email && <div className="text-danger fs-12">{errors.email}</div>}
										</div>
										<div className="form-group mb-3">
											<label className="mb-1"><strong>Mot de passe</strong></label>
											<input
											  type="password"
											  className="form-control"
											  value={password}
											  placeholder="Type Your Password"
												onChange={(e) =>
													setPassword(e.target.value)
												}
												disabled={props.showLoading}
											/>
											{errors.password && <div className="text-danger fs-12">{errors.password}</div>}
										</div>
										<div className="form-row d-flex justify-content-between mt-4 mb-2">
											<div className="form-group mb-3">
											   <div className="custom-control custom-checkbox ml-1">
													<input type="checkbox" className="form-check-input" id="basic_checkbox_1" disabled={props.showLoading} />
													<label className="form-check-label" htmlFor="basic_checkbox_1">se souvenir de moi</label>
												</div>
											</div>
										</div>
										<div className="text-center form-group mb-3">
											<button type="submit" className="btn btn-primary btn-block" disabled={props.showLoading}>
												{props.showLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Connexion...
                                                    </>
                                                ) : (
                                                    <>Se connecter</>
                                                )}
											</button>
										</div>
									</form>
									<div className="new-account mt-3">
										<p>Vous n'avez pas de compte? <Link className="text-primary" to="/register">S'inscrire</Link></p>
										<p className="mt-2"><Link className="text-primary" to="/password/forgot">Mot de passe oublié ?</Link></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>	
		
  );
};

const mapStateToProps = (state) => {
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};
export default connect(mapStateToProps)(Login);
